module.exports = __webpack_public_path__ + "static/media/fawry-logo1.955a63c5.png";